module.exports = __webpack_public_path__ + "Server-Disabled.AzureSubscription.4ff9838d4812cb8ae3bbd5120bea1bfa.hashedasset.svg";